import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-center align-center my-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_tooltip, { location: "bottom" }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_btn, _mergeProps({
          class: "mr-2 mt-1",
          fab: "",
          elevation: "0"
        }, props, {
          color: "#FFF",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.checksDialog = true))
        }), {
          default: _withCtx(() => [
            _createVNode(_component_v_badge, {
              color: _ctx.errorsCount > 0 ? 'red' : 'primary',
              content: _ctx.errorsCount
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "x-large",
                  color: _ctx.errorsCount > 0 ? 'red' : 'primary',
                  class: "pb-1"
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("$oss-warning")
                  ])),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            }, 8, ["color", "content"])
          ]),
          _: 2
        }, 1040)
      ]),
      default: _withCtx(() => [
        _cache[4] || (_cache[4] = _createElementVNode("span", null, "Contrôle de cohérence", -1))
      ]),
      _: 1
    }),
    (_ctx.checksDialog)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 0,
          modelValue: _ctx.checksDialog,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checksDialog) = $event)),
          title: "Contrôle de cohérence",
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checksDialog = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              style: {"width":"750px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    (!_ctx.errorsCount)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_1, [
                          _createVNode(_component_v_icon, {
                            color: "green",
                            class: "mr-2"
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode("$oss-circle-check")
                            ])),
                            _: 1
                          }),
                          _cache[6] || (_cache[6] = _createTextVNode(" Tous les contrôles ont été validés "))
                        ]))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.errorMessages, (errorMessage) => {
                          return (_openBlock(), _createElementBlock("b", {
                            key: errorMessage,
                            class: "d-flex justify-center align-center my-5"
                          }, [
                            _createVNode(_component_v_icon, {
                              class: "mr-2",
                              color: "red"
                            }, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createTextVNode("$oss-warning")
                              ])),
                              _: 1
                            }),
                            _createTextVNode(" " + _toDisplayString(errorMessage), 1)
                          ]))
                        }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}